(function () {
    'use strict';

    angular.module('vhols')

        .directive('liveChat', ['ChatStatus', '$window', '$timeout', function (chatStatus, $window, $timeout) {
            return {
                link: function (scope) {
                    var mobileWidth = 768;
                    //this really is not ideal but currently scrolling content in fixed elements craps itself on ipad
                    var isIpad = navigator.userAgent.match(/iPad/i) != null;
                    var iframeID = 'clickToChat';
                    var div = document.createElement('div');
                    var iframe = document.createElement('iframe');
                    var source = $window.location.protocol + '//' +  $window.location.host + $window.location.pathname;
                    var frameSrc = $window.location.protocol + '//' +  $window.location.host + '/click-to-chat/?skillSet=WC_Service&source=' + source;


                    div.id = "clickToChatFrameWrapper";

                    div.style.display = "none";
                    iframe.id = iframeID;
                    iframe.src = frameSrc;
                    iframe.setAttribute("frameBorder", 0);

                    div.appendChild(iframe);

                    document.body.insertBefore(div, document.body.firstChild);

                    scope.$watch(function() {
                        return chatStatus.data;
                    }, function(newValue) {
                        if (newValue.response != null) {

                            $timeout(function() {
                                scope.hideChatLink = (newValue.response == 'NOT_READY' || newValue.response == 'OFFLINE');
                                scope.chatLoaded = true;
                            });

                            if (newValue.response == 'OFFLINE') {
                                chatStatus.stopPolling();
                            }

                            if (newValue.response == 'IN_QUEUE' || newValue.response == 'CONNECTED') {
                                if(window.innerWidth < mobileWidth || isIpad) {
                                    document.body.style.position = 'fixed';
                                }
                                div.style.display = "block";
                                chatStatus.stopPolling();
                            }
                        }

                    }, true);

                    function toggle(element, klass) {
                        var classes = element.className.match(/\S+/g) || [],
                            index = classes.indexOf(klass);

                        index >= 0 ? classes.splice(index, 1) : classes.push(klass);
                        element.className = classes.join(' ');
                    }

                    scope.startChat = function() {
                        var data = { class: '' };

                        if (window.innerWidth < mobileWidth || isIpad) {
                            document.body.style.position = 'fixed';
                        }
                        div.style.display = 'block';
                        resizeIFrameToFitContent(data);
                        tracking('Chat: Window Opened');
                    };

                    function resizeIFrameToFitContent(data) {
                        if(data.class != '' && data.class != null) {
                            var clazz = (isIpad) ? 'ipad ' + data.class : data.class;
                            clazz = (div.className.indexOf('minimised') > 0) ? clazz + ' minimised' : clazz;
                            div.setAttribute("class", clazz || '');
                        }
                    }

                    function tracking(evtName) {
                        window.postMessage({name: evtName, data: '', category: 'Click To Chat', class: ''}, window.location.protocol + '//' +  window.location.host);
                    }

                    window.addEventListener("message", receiveMessage, false);

                    function receiveMessage(event) {

                        if (event.data.status == 'MINIMISE') {
                            div.style.minHeight = '0';
                            toggle(div, 'minimised');

                            if (window.innerWidth < mobileWidth || isIpad) {
                                document.body.style.position = document.body.style.position === 'fixed' ? 'static' : 'fixed';
                            }
                            iframe.contentDocument.body.style.position = iframe.contentDocument.body.style.position === 'fixed' ? 'static' : 'fixed';
                        } else {
                            resizeIFrameToFitContent(event.data);
                        }

                        if(event.data.status == 'CLOSE') {
                            document.body.style.position = 'static';
                            iframe.contentDocument.body.style.overflow = 'auto';
                            div.style.display = 'none';
                            div.style.minHeight = '0';
                            div.classList.remove('minimised');
                        }

                        if (event.data.status == 'MODAL') {
                            div.style.minHeight = '250px';
                        }

                        if (event.data.status == 'CANCEL') {
                            div.style.minHeight = '0px';
                        }
                    }

                }
            };
        }])

        .directive('thumbnailImageCarousel', ['$interpolate', function ($interpolate) {
            var CAROUSEL_INDICATORS = 'carousel-indicators';
            var LI = 'li';
            var BACKGROUND_IMAGE_TEMPLATE = $interpolate('background-image:url(/dam/{{image}});');

            return {
                scope: {
                    thumbImages: '='
                },
                link: function ($scope, $element) {
                    var $el = $element[0];

                    $scope.$watch(function () {
                        var indicatorContainer = $el.getElementsByClassName(CAROUSEL_INDICATORS);

                        if (indicatorContainer.length > 0) {
                            return indicatorContainer[0].getElementsByTagName(LI).length;
                        }

                        return 0;
                    }, function (indicatorsLength) {
                        if (indicatorsLength > 0) {
                            var $indicatorList = $el.getElementsByClassName(CAROUSEL_INDICATORS)[0].getElementsByTagName(LI);

                            angular.forEach($indicatorList, function (indicator, index) {
                                indicator.setAttribute('style', BACKGROUND_IMAGE_TEMPLATE({
                                    image: $scope.thumbImages[index].image
                                }));
                            });
                        }
                    });

                }
            };
        }])

        .directive('contactTiles', [function () {
            return {
                restrict: 'A',
                link: function(scope, element) {
                    setTimeout(function() {
                        var ACTIVE_CLASS = 'active';
                        var HIDE_CLASS = 'ct-hide';

                        var $groupWrap = angular.element(element[0].getElementsByClassName('contact-tile-group'));
                        var $contentWrap = angular.element(element[0].getElementsByClassName('contact-tile-content'));
                        var $ctaWrap = angular.element(element[0].getElementsByClassName('contact-tile-cta-wrap'));
                        var $ctaButtons = $ctaWrap.find('button');

                        flush();

                        function flush() {
                            $groupWrap.removeClass(ACTIVE_CLASS);
                            $contentWrap.addClass(HIDE_CLASS);
                            $ctaWrap.removeClass(HIDE_CLASS);
                        }

                        if ($ctaButtons.length) {
                            angular.forEach($ctaButtons, function(cta) {
                                var ctaEl = angular.element(cta);
                                ctaEl.on('click', onClick);
                            });
                        }

                        function onClick(event) {
                            var ctaWrap = event.target.parentNode;
                            var parent = ctaWrap.parentNode;
                            var content = parent.getElementsByClassName('contact-tile-content');

                            flush();
                            angular.element(parent).addClass(ACTIVE_CLASS);
                            angular.element(content).removeClass(HIDE_CLASS);
                            angular.element(ctaWrap).addClass(HIDE_CLASS);
                        }

                        scope.$on('$destroy', function () {
                            if ($ctaButtons.length) {
                                angular.forEach($ctaButtons, function(cta) {
                                    var ctaEl = angular.element(cta);
                                    ctaEl.off('click', onClick);
                                });
                            }
                        });
                    }, 100);
                }
            };
        }]);
})();
